import React, { useEffect, useState } from "react";
import ServiceCard from "../../../components/ServiceCard";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import SectionHeader from "./SectionHeader";
import axios from "axios";
import { useSelector } from "react-redux";
import ServiceCardPlaceholder from "./placeholders/ServiceCardPlaceholder";
import { getContent } from "../../../utils/main";

const Services = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isServicesLoading, setIsServicesLoading] = useState(true);
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/services/`)
      .then((res) => {
        setServices(res.data);
      })
      .then(() => {
        setIsServicesLoading(false);
      });
  }, []);

  const controlCard = useAnimation();
  const [refCard, inViewCard] = useInView();
  const list = {
    visible: {
      opacity: 1,
      transition: {
        type: "spring",
        when: "",
        staggerChildren: 0.1,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        when: "afterChildren",
      },
    },
  };
  useEffect(() => {
    if (inViewCard) {
      controlCard.start("visible");
    }
  }, [controlCard, inViewCard]);
  return (
    <div className="services-wrapper mt-4">
      <div className="container">
        <div className="row">
          <SectionHeader
            title={getContent(content, "Services", lang)}
            content={getContent(content, "Services content", lang)}
          />
          <div className="clearfix"></div>
          {isServicesLoading === true ? (
            <>
              <ServiceCardPlaceholder />
              <ServiceCardPlaceholder />
              <ServiceCardPlaceholder />
              <ServiceCardPlaceholder />
              <ServiceCardPlaceholder />
              <ServiceCardPlaceholder />
            </>
          ) : (
            <div>
              <motion.div
                variants={list}
                ref={refCard}
                initial="hidden"
                animate={controlCard}
                className="row justify-content-center"
              >
                {services.map((service) => (
                  <ServiceCard service={service} key={service["id"]} />
                ))}
              </motion.div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Services;
